<div class="courses">
  <div
    class="cards-container"
    [ngClass]="{
      'grid-layout': currentLayoutView === 'CardView' || currentLayoutView === 'SnakeView',
      'list-layout': currentLayoutView === 'ListView' || currentLayoutView === 'NumberedListView',
    }"
  >
    @for (card of cards; track card._id) {
      <ptl-card-item
        role="listitem"
        class="card-item"
        [card]="card"
        [viewType]="currentLayoutView"
        (cardClick)="onCardClick($event)"
      ></ptl-card-item>
    }
  </div>
</div>
